import { render } from "./UploadPlanilhasVeiculo.vue?vue&type=template&id=ac1693f4&scoped=true&ts=true"
import script from "./UploadPlanilhasVeiculo.vue?vue&type=script&lang=ts"
export * from "./UploadPlanilhasVeiculo.vue?vue&type=script&lang=ts"

import "./UploadPlanilhasVeiculo.vue?vue&type=style&index=0&id=ac1693f4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1693f4"]])

export default __exports__